import type { ShapeDrawAction } from './shapeDraw.action';
import {
  startShapeDraw, stopShapeDraw,
} from './shapeDraw.actionCreators';
import type { ShapeDrawState } from './shapeDraw.state';

const initialState: ShapeDrawState = {
  isActive: false,
};

export const shapeDrawReducer = (state = initialState, action: ShapeDrawAction): ShapeDrawState => {

  if (startShapeDraw.match(action)) {
    return {
      ...state,
      isActive: true,
      shape: action.payload.shape,
      configuration: action.payload.configuration,
    };
  }

  if (stopShapeDraw.match(action)) {
    return {
      ...state,
      isActive: false,
    };
  }

  return state;
};
